<template>
  <div class="mx-auto w-full">
    <Label
      :for="name"
      :class="['pointer-events-none bg-background px-2 text-sm', error && '!text-destructive']"
      >{{ label }}</Label
    >
    <PinInput
      ref="pinInputRef"
      id="pin-input"
      v-model="characters"
      placeholder="○"
      class="block w-full"
    >
      <PinInputGroup
        class="grid w-full"
        :style="`grid-template-columns: repeat(${passwordLength}, 1fr)`"
      >
        <PinInputInput
          v-for="(id, index) in passwordLength"
          :key="id"
          :index="index"
          :autofocus="index === 0"
          type="text"
          class="h-9 w-full text-center text-lg first:rounded-l-md last:rounded-r-md [&:not(:first-child)]:border-l-0 [&:not(:placeholder-shown)]:text-clip [&:not(:placeholder-shown)]:font-bold"
          :style="characters[index] ? { '-webkit-text-security': 'disc' } : {}"
          autocomplete="off"
        />
      </PinInputGroup>
    </PinInput>
  </div>
</template>

<script setup lang="ts">
import Label from '@ui/label/Label.vue';
import { PinInput, PinInputGroup, PinInputInput } from '@ui/pin-input';
import { computed, ref, watch } from 'vue';

withDefaults(
  defineProps<{
    name: string;
    label: string;
    error?: string;
    passwordLength?: number;
  }>(),
  {
    passwordLength: 5,
  },
);

const modelValue = defineModel<string>('modelValue', { required: true });
const pinInputRef = ref<InstanceType<typeof PinInput> | null>(null);

const characters = computed({
  get() {
    return (modelValue.value || '')?.split('') || [];
  },
  set(value: string[]) {
    const newValue = value.join('');
    modelValue.value = newValue;
  },
});

watch(modelValue, (newValue) => {
  if (!newValue && pinInputRef.value) {
    // Focus the first input when the model value is cleared
    const inputs = pinInputRef.value.$el.querySelectorAll('input');
    if (inputs.length > 0) {
      inputs[0].focus();
    }
  }
});
</script>
